module.exports = __webpack_public_path__ + "img/100_PAB_2021_PABIcon.42179827.png";